import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/lib/api";

export function useNouvelleTemplates(enabled) {
  const [data, setData] = useState({ templates: [], synced_at: null });
  const load = () => api.nouvelleTemplates().then(setData).catch(() => {});
  useEffect(() => { if (enabled) load(); }, [enabled]);
  return { ...data, reload: load };
}

export function NouvelleTemplateSelect({ value, onChange, templates, testId }) {
  const known = templates.some((t) => t.id === value);
  return (
    <select value={known ? value : ""} onChange={(e) => onChange(e.target.value)} className="h-8 rounded-md border border-input bg-background text-xs px-2 w-full" data-testid={testId}>
      <option value="">— testo libero (solo entro 24h) —</option>
      {templates.map((t) => <option key={t.id} value={t.id} disabled={t.status && t.status !== "APPROVED"}>{t.name}{t.status && t.status !== "APPROVED" ? ` (${t.status.toLowerCase()})` : ""}{t.variables?.length ? ` · ${t.variables.length} var` : ""}</option>)}
    </select>
  );
}

export function NouvelleSyncBar({ synced_at, count, onSynced }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const sync = async () => {
    setBusy(true);
    try { const r = await api.nouvelleSyncTemplates(email, pw); toast.success(`${r.count} template sincronizzati da Nouvelle WhatsApp`); setOpen(false); setPw(""); onSynced(); } catch (e) { toast.error(e?.response?.data?.detail || "Sincronizzazione non riuscita"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-[var(--nc-blue)]/30 bg-[var(--nc-required)]/60 p-3 space-y-2 text-xs" data-testid="nouvelle-sync-bar">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <span><b>Template Nouvelle WhatsApp</b>: {count} disponibili{synced_at ? ` · sincronizzati ${new Date(synced_at).toLocaleString("it-IT")}` : " · mai sincronizzati"}. Scegli un template per ogni esito così i messaggi partono anche fuori dalla finestra 24h.</span>
        <Button size="sm" variant="outline" className="h-7 text-xs gap-1" onClick={() => setOpen((v) => !v)} data-testid="nouvelle-sync-toggle"><RefreshCw className="h-3 w-3" /> Sincronizza template</Button>
      </div>
      {open && (
        <div className="flex gap-2 flex-wrap items-end">
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email account Nouvelle" className="h-8 text-xs w-56 bg-white" data-testid="nouvelle-sync-email" />
          <Input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Password" className="h-8 text-xs w-44 bg-white" data-testid="nouvelle-sync-password" />
          <Button size="sm" className="h-8 text-xs" disabled={busy || !email || !pw} onClick={sync} data-testid="nouvelle-sync-run">Importa</Button>
          <span className="text-[11px] text-muted-foreground">Le credenziali servono solo per questa lettura e non vengono salvate.</span>
        </div>
      )}
    </div>
  );
}
